import DescriptionStrategy from './DescriptionStrategy'
import messageResource from '../../../../messageResource'
import {Feature} from '../../../../features/constants'
import {AccessRights} from 'constants'

export default class OvertimeDescriptionStrategy extends DescriptionStrategy {
    constructor({
        reportUrl = '',
        name = '',
    }) {
        super()

        this.params = {
            reportUrl,
            name,
        }

        this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
            overtimeAvailable: false,
        }

        this.userType = null

        this.onStatePropertyChanged('userRights', (userRights) => {
            if (userRights[AccessRights.MANAGE_PTO_AND_SICK] || userRights[AccessRights.MANAGE_USERS])
                this.userType = UserTypes.MANAGE_PTO_AND_AP
            else if (userRights[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                this.userType = UserTypes.USER_WITH_MODIFY_OTHERS
            } else {
                this.userType = userRights[AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT
            }
        })
    }

    getHeader() {
        return messageResource.getMessage(this.params.name) + ' ' + messageResource.getMessage('report.common.report')
    }

    getDescription() {
        const overtimeAvailable = this.state.overtimeAvailable
        const overtimeFeatureEnabled = !!this.state.enabledFeatures[Feature.OVR]
        const leaveTimeFeature = !!this.state.enabledFeatures[Feature.LVT]

        let firstParagraph
        let secondParagraph
        let thirdParagraph
        switch (this.userType) {
            case UserTypes.REGULAR_WITH_TT:
                firstParagraph = overtimeAvailable ? messageResource.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part1.overtime')
                                                   : messageResource.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part1')
                secondParagraph = overtimeAvailable ? messageResource.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part2.overtime')
                                                    : messageResource.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part2')
                thirdParagraph = leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part3') : ''
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.REGULAR_WITHOUT_TT:
                return ''
            case UserTypes.MANAGE_PTO_AND_AP:
                firstParagraph = overtimeFeatureEnabled ? messageResource.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part1.overtime')
                                                   : messageResource.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part1')
                secondParagraph = overtimeFeatureEnabled ? messageResource.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part2.overtime')
                                                    : messageResource.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part2')
                thirdParagraph = leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part3') : ''
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
            case UserTypes.USER_WITH_MODIFY_OTHERS:
                firstParagraph = overtimeFeatureEnabled ? messageResource.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part1.overtime')
                                                   : messageResource.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part1')
                secondParagraph = overtimeFeatureEnabled ? messageResource.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part2.overtime')
                                                    : messageResource.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part2')
                thirdParagraph = leaveTimeFeature ? messageResource.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part3') : ''
                return this._createDescription(firstParagraph, secondParagraph, thirdParagraph)
        }
    }

    _createDescription(first, second, third) {
        return '<div>' +
               '  <div class="firstParagraph">' + first + '</div>' +
               '  <div class="secondParagraph">' + second + '</div>' +
               '  <div class="thirdParagraph">' + third + '</div>' +
               '</div>'
    }

    getDetailsCallback() {
        openUserGuidePage('reporting#report-overtime')
    }

    getGenerateCallback() {
        window.location.href = this.params.reportUrl
    }
}

const UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    MANAGE_PTO_AND_AP: 'UserWithManagePTOandAPPermissions',
    USER_WITH_MODIFY_OTHERS: 'UserWithSubmitOtherTTRight',
}



// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/OvertimeDescriptionStrategy.js